// usage: log('inside coolFunc', this, arguments);
// paulirish.com/2009/log-a-lightweight-wrapper-for-consolelog/
window.log = function f() {
  log.history = log.history || [];
  log.history.push(arguments);
  if (this.console) {
    var args = arguments,
      newarr;
    args.callee = args.callee.caller;
    newarr = [].slice.call(args);
    if (typeof console.log === "object")
      log.apply.call(console.log, console, newarr);
    else console.log.apply(console, newarr);
  }
};

// make it safe to use console.log always
(function(a) {
  function b() {}
  for (
    var c = "assert,count,debug,dir,dirxml,error,exception,group,groupCollapsed,groupEnd,info,log,markTimeline,profile,profileEnd,time,timeEnd,trace,warn".split(
        ","
      ),
      d;
    !!(d = c.pop());

  ) {
    a[d] = a[d] || b;
  }
})(
  (function() {
    try {
      console.log();
      return window.console;
    } catch (a) {
      return (window.console = {});
    }
  })()
);

/*
 * Add commas to a long number.
 */
function addCommas(nStr) {
  nStr += "";
  x = nStr.split(".");
  x1 = x[0];
  x2 = x.length > 1 ? "." + x[1] : "";
  var rgx = /(\d+)(\d{3})/;
  while (rgx.test(x1)) {
    x1 = x1.replace(rgx, "$1" + "," + "$2");
  }
  return x1 + x2;
}

global.addCommas = addCommas;

/*
 * 	Normalizes a selector
 */
function normalizeSelector(selector, defSelector, toAdd) {
  defSelector = defSelector || "#";
  toAdd = toAdd || "";

  if (selector.charAt(0).search(/\#|\./) < 0) {
    selector = defSelector + selector + toAdd;
  }

  return selector;
}

global.normalizeSelector = normalizeSelector;

/* @projectDescription jQuery Serialize Anything - Serialize anything (and not just forms!)
 * @author Bramus! (Bram Van Damme)
 * @version 1.0
 * @website: http://www.bram.us/
 * @license : BSD
 */

(function($) {
  $.fn.serializeAnything = function() {
    var toReturn = [];
    var els = $(this)
      .find(":input")
      .get();

    $.each(els, function() {
      if (
        this.name &&
        !this.disabled &&
        (this.checked ||
          /select|textarea/i.test(this.nodeName) ||
          /text|hidden|password/i.test(this.type))
      ) {
        var val = $(this).val();
        toReturn.push(
          encodeURIComponent(this.name) + "=" + encodeURIComponent(val)
        );
      }
    });

    return toReturn.join("&").replace(/%20/g, "+");
  };
})(jQuery);
